import React, { useState } from "react";
import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  HStack,
  Text,
  useDisclosure,
  useTheme
} from "@chakra-ui/react";
import { FaCheck } from "react-icons/fa";
import { FiGrid } from "react-icons/fi";

const ViewTypeComponent = ({ viewType, setViewType }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [selected, setSelected] = useState(viewType);

  const options = ["List", "Grid", "Table"];

  const isActive = (viewType !== "List");

  const { colors } = useTheme();

  const handleApply = () => {
    onClose();
    setViewType(selected);
  };

  return (
    <Box>
      <Button
        variant="primary"
        borderRadius="full"
        onClick={onOpen}
        color={isActive ? "pureWhite" : "pureBlack"}
        bg={isActive ? "teal" : "gray.100"}
        fontSize="body.xs"
        rightIcon={<FiGrid color={colors.limeShade[600]} />}
        size="sm">
        View {isActive ? `: ${viewType}` : ""}
      </Button>

      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent
          bg="gray.50"
          borderColor="gray.200"
        >
          <DrawerCloseButton />
          <DrawerHeader
            fontSize="heading.m"
            color="gray.600"
          >Group by</DrawerHeader>
          <DrawerBody>
            <Box
              p={0}
              m={0}
              borderRadius="lg"
              color="gray.100"
            >

              {options.map((option) => (
                <HStack
                  key={option}
                  justify="space-between"
                  py={3}
                  px={4}
                  borderWidth="1px 0px 1px 0px"
                  borderColor="gray.200"
                  cursor="pointer"
                  onClick={() => setSelected(option)}
                >
                  <Text
                    fontWeight={selected === option ? "bold" : "normal"}
                    color={selected === option ? "teal" : "gray.500"}
                  >
                    {option}
                  </Text>
                  {selected === option && (
                    <FaCheck color="limegreen" />
                  )}
                </HStack>
              ))}
              {/*</VStack>*/}
            </Box>
          </DrawerBody>
          <DrawerFooter>
            <Button variant="primary" mt={4} colorScheme="blue" onClick={() => handleApply()}>
              Apply
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};

export default ViewTypeComponent;